<template>
  <AppTemplate>
    <template #title>Projets ({{ lines }})</template>
    <div class="card card-body p-2">
        <AsdecodeTable class="mb-4" :columns="columns" url="/api/projets" table="projets" @set-total-records="updateLines"
            @row-click="showLine" @set-selected-rows="getSelection">

            <template #statut="slotProps">
                <span class="p-2 rounded-pill badge badge-primary">{{ slotProps.data.statut }}</span>
            </template>
        </AsdecodeTable>
    </div>
  </AppTemplate>
</template>

<script>
import { defineComponent } from 'vue';
import FormProjet from './FormProjet.vue';
import ShowProjet from './ShowProjet.vue';

export default defineComponent({
    name: 'IndexProjet',

    data() {
        return {
            lines: 0,
            selection: [],
            columns: [
                {
                    key: 'title',
                    label: 'Titre',
                    sortable: true,
                    exportable: true,
                },
                {
                    key: 'country_code',
                    label: 'Code pays',
                    sortable: true,
                    exportable: true,
                },
                {
                    key: 'visibility',
                    label: 'Visibilité',
                },
                {
                    key: 'plan',
                    label: 'Option',
                },
                {
                    key: 'budget',
                    label: 'Budget',
                    format: 'money',
                },
                {
                    key: 'created_at',
                    label: 'Ajouté le',
                    format: 'datetime',
                },
                {
                    key: 'status',
                    label: 'Statut',
                    sortable: true,
                    exportable: true,
                }
            ]
        }
    },
    methods: {
        showLine(line) {
            this.$dialog.open(ShowProjet, {
                props: {
                    header: 'Projet ID'+line.id,
                    style: { width: '50vw' },
                    modal: true,
                },
                data: line
            });
        },
        updateLines(nb) {
            this.lines = nb
        },
        // getSelection(selection) {
        //     this.selection = selection
        // },
        showCreateModal() {
            this.$dialog.open(FormProjet, {
                props: {
                    header: 'Ajouter un projet',
                    style: { width: '50vw' },
                    modal: true,
                },

            });
        },
    },
});
</script>